//ruoter中 为了区分pc和移动端 在移动端最后写为/wap
//在routerjs中路由守卫中兼容
const mountains = [
  {
    path: '/',
    name: 'mountains',
    meta: {
      title: '山川屿你',
    },
    component: () => import('../../pages/mountains/index.vue'),
  },
  {
    path: '/wap',
    name: '/wap',
    meta: {
      title: '山川屿你',
    },
    component: () => import('../../pages/wap/index.vue'),
  },
  {
    path: '/show/:param',
    name: '/show',
    meta: {
      title: '山川屿你',
    },
    component: () => import('../../pages/h5/index.vue'),
  },
  {
    path: '/enterpriseIdentityAuthentication',
    name: '/enterpriseIdentityAuthentication',
    meta: {
      title: '山川屿你',
    },
    component: () =>
      import('../../pages/enterpriseIdentityAuthentication/index.vue'),
  },
  {
    path: '/pay',
    name: 'iosPay',
    meta: {
      title: '山川贝',
    },
    component: () => import('@/pages/h5/iosPay.vue'),
  },
  {
    path: '/vipPay',
    name: 'vipPay',
    meta: {
      title: '会员支付',
    },
    component: () => import('@/pages/h5/vipPay.vue'),
  },
  {
    path: '/account-detail',
    name: 'account-detail',
    meta: {
      title: '金币明细',
    },
    component: () => import('@/pages/h5/accountDetail.vue'),
  },
];

export default mountains;
